import _ from 'lodash';

export const DEMO_ROUTES = [
  'customer-profile-def',
  'liveboards',
  'phrase-suggestions',
  'topic-suggestions',
  'external-customer-lookup/action-forms',
  'email-suggestions',
  'greeting-suggestions',
];

function isDemoRoute(url) {
  if (_.some(DEMO_ROUTES, demoRoute => url.includes(demoRoute))) {
    return true;
  }

  if (url.includes('reports') && !url.includes('embedded-reports')) {
    return true;
  }

  return false;
}

export default class DemoRestClient {
  constructor(xhrAdapter, localRest) {
    this._xhrAdapter = xhrAdapter;
    this._localRest = localRest;
  }

  post(url, obj, cb, opts) {
    return this._xhrAdapter.post(url, obj, cb, opts);
  }

  get(url, cb, opts) {
    if (isDemoRoute(url)) {
      return this._localRest.get(url, cb);
    }
    return this._xhrAdapter.get(url, cb, opts);
  }

  put(url, obj, cb, opts) {
    return this._xhrAdapter.put(url, obj, cb, opts);
  }

  postUpload(url, obj, listeners, opts) {
    return this._xhrAdapter.postUpload(url, obj, listeners, opts);
  }

  delete(url, cb, opts) {
    return this._xhrAdapter.delete(url, cb, opts);
  }

  axios() {
    return new AxiosDemoClient(this._xhrAdapter.axios(), this._localRest.axios());
  }
}

class AxiosDemoClient {
  constructor(httpClient, localRestBackendAxios) {
    this._httpClient = httpClient;
    this._localRestBackendAxios = localRestBackendAxios;
  }

  get(url, config) {
    if (isDemoRoute(url)) {
      return this._localRestBackendAxios.get(url, config);
    }
    return this._httpClient.get(url, config);
  }

  post(url, body, config) {
    if (isDemoRoute(url)) {
      return this._localRestBackendAxios.post(url, body, config);
    }
    return this._httpClient.post(url, body, config);
  }

  put(url, body, config) {
    return this._httpClient.put(url, body, config);
  }

  delete(url, config) {
    return this._httpClient.delete(url, config);
  }

  patch(url, body, config) {
    return this._httpClient.patch(url, body, config);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/demo_rest_client.js